import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import Vue from 'vue';
import QIcon from "../icon/QIcon.js";
import QResizeObserver from "../resize-observer/QResizeObserver.js";
import TimeoutMixin from "../../mixins/timeout.js";
import ListenersMixin from "../../mixins/listeners.js";
import { stop, noop } from "../../utils/event.js";
import { slot } from "../../utils/slot.js";
import cache from "../../utils/cache.js";

function getIndicatorClass(color, top, vertical) {
  var pos = vertical === true ? ['left', 'right'] : ['top', 'bottom'];
  return "absolute-".concat(top === true ? pos[0] : pos[1]).concat(color ? " text-".concat(color) : '');
}

function bufferPrioritySort(t1, t2) {
  if (t1.priorityMatched === t2.priorityMatched) {
    return t2.priorityHref - t1.priorityHref;
  }

  return t2.priorityMatched - t1.priorityMatched;
}

function bufferCleanSelected(t) {
  t.selected = false;
  return t;
}

var bufferFilters = [function (t) {
  return t.selected === true && t.exact === true && t.redirected !== true;
}, function (t) {
  return t.selected === true && t.exact === true;
}, function (t) {
  return t.selected === true && t.redirected !== true;
}, function (t) {
  return t.selected === true;
}, function (t) {
  return t.exact === true && t.redirected !== true;
}, function (t) {
  return t.redirected !== true;
}, function (t) {
  return t.exact === true;
}, function (t) {
  return true;
}],
    bufferFiltersLen = bufferFilters.length;
export default Vue.extend({
  name: 'QTabs',
  mixins: [TimeoutMixin, ListenersMixin],
  provide: function provide() {
    return {
      tabs: this.tabs,
      __recalculateScroll: this.__recalculateScroll,
      __activateTab: this.__activateTab,
      __activateRoute: this.__activateRoute
    };
  },
  props: {
    value: [Number, String],
    align: {
      type: String,
      default: 'center',
      validator: function validator(v) {
        return ['left', 'center', 'right', 'justify'].includes(v);
      }
    },
    breakpoint: {
      type: [String, Number],
      default: 600
    },
    vertical: Boolean,
    shrink: Boolean,
    stretch: Boolean,
    activeColor: String,
    activeBgColor: String,
    indicatorColor: String,
    leftIcon: String,
    rightIcon: String,
    outsideArrows: Boolean,
    mobileArrows: Boolean,
    switchIndicator: Boolean,
    narrowIndicator: Boolean,
    inlineLabel: Boolean,
    noCaps: Boolean,
    dense: Boolean,
    contentClass: String
  },
  data: function data() {
    return {
      tabs: {
        current: this.value,
        activeColor: this.activeColor,
        activeBgColor: this.activeBgColor,
        indicatorClass: getIndicatorClass(this.indicatorColor, this.switchIndicator, this.vertical),
        narrowIndicator: this.narrowIndicator,
        inlineLabel: this.inlineLabel,
        noCaps: this.noCaps
      },
      scrollable: false,
      leftArrow: true,
      rightArrow: false,
      justify: false
    };
  },
  watch: {
    value: function value(name) {
      this.__activateTab(name, true, true);
    },
    activeColor: function activeColor(v) {
      this.tabs.activeColor = v;
    },
    activeBgColor: function activeBgColor(v) {
      this.tabs.activeBgColor = v;
    },
    vertical: function vertical(v) {
      this.tabs.indicatorClass = getIndicatorClass(this.indicatorColor, this.switchIndicator, v);
    },
    indicatorColor: function indicatorColor(v) {
      this.tabs.indicatorClass = getIndicatorClass(v, this.switchIndicator, this.vertical);
    },
    switchIndicator: function switchIndicator(v) {
      this.tabs.indicatorClass = getIndicatorClass(this.indicatorColor, v, this.vertical);
    },
    narrowIndicator: function narrowIndicator(v) {
      this.tabs.narrowIndicator = v;
    },
    inlineLabel: function inlineLabel(v) {
      this.tabs.inlineLabel = v;
    },
    noCaps: function noCaps(v) {
      this.tabs.noCaps = v;
    },
    outsideArrows: function outsideArrows() {
      this.$nextTick(this.__recalculateScroll());
    },
    arrowsEnabled: function arrowsEnabled(v) {
      this.__updateArrows = v === true ? this.__updateArrowsFn : noop;
      this.$nextTick(this.__recalculateScroll());
    }
  },
  computed: {
    arrowsEnabled: function arrowsEnabled() {
      return this.$q.platform.is.desktop === true || this.mobileArrows === true;
    },
    alignClass: function alignClass() {
      var align = this.scrollable === true ? 'left' : this.justify === true ? 'justify' : this.align;
      return "q-tabs__content--align-".concat(align);
    },
    classes: function classes() {
      return "q-tabs--".concat(this.scrollable === true ? '' : 'not-', "scrollable") + " q-tabs--".concat(this.vertical === true ? 'vertical' : 'horizontal') + " q-tabs__arrows--".concat(this.arrowsEnabled === true && this.outsideArrows === true ? 'outside' : 'inside') + (this.dense === true ? ' q-tabs--dense' : '') + (this.shrink === true ? ' col-shrink' : '') + (this.stretch === true ? ' self-stretch' : '');
    },
    innerClass: function innerClass() {
      return this.alignClass + (this.contentClass !== void 0 ? " ".concat(this.contentClass) : '') + (this.$q.platform.is.mobile === true ? ' scroll' : '');
    },
    domProps: function domProps() {
      return this.vertical === true ? {
        container: 'height',
        content: 'offsetHeight',
        scroll: 'scrollHeight'
      } : {
        container: 'width',
        content: 'offsetWidth',
        scroll: 'scrollWidth'
      };
    },
    onEvents: function onEvents() {
      return _objectSpread({
        input: stop
      }, this.qListeners);
    }
  },
  methods: {
    __activateTab: function __activateTab(name, setCurrent, skipEmit) {
      if (this.tabs.current !== name) {
        skipEmit !== true && this.$emit('input', name);

        if (setCurrent === true || this.qListeners.input === void 0) {
          this.__animate(this.tabs.current, name);

          this.tabs.current = name;
        }
      }
    },
    __activateRoute: function __activateRoute(params) {
      var _this = this;

      if (this.bufferRoute !== this.$route && this.buffer.length > 0) {
        clearTimeout(this.bufferTimer);
        this.bufferTimer = void 0;
        this.buffer.length = 0;
      }

      this.bufferRoute = this.$route;

      if (params !== void 0) {
        if (params.remove === true) {
          this.buffer = this.buffer.filter(function (t) {
            return t.name !== params.name;
          });
        } else {
          this.buffer.push(params);
        }
      }

      if (this.bufferTimer === void 0) {
        this.bufferTimer = setTimeout(function () {
          var tabs = [];

          for (var i = 0; i < bufferFiltersLen && tabs.length === 0; i++) {
            tabs = _this.buffer.filter(bufferFilters[i]);
          }

          tabs.sort(bufferPrioritySort);

          _this.__activateTab(tabs.length === 0 ? null : tabs[0].name, true);

          _this.buffer = _this.buffer.map(bufferCleanSelected);
          _this.bufferTimer = void 0;
        }, 1);
      }
    },
    __recalculateScroll: function __recalculateScroll() {
      var _this2 = this;

      this.__nextTick(function () {
        _this2._isDestroyed !== true && _this2.__updateContainer({
          width: _this2.$el.offsetWidth,
          height: _this2.$el.offsetHeight
        });
      });

      this.__prepareTick();
    },
    __updateContainer: function __updateContainer(domSize) {
      var _this3 = this;

      var size = domSize[this.domProps.container],
          scrollSize = Math.min(this.$refs.content[this.domProps.scroll], Array.prototype.reduce.call(this.$refs.content.children, function (acc, el) {
        return acc + el[_this3.domProps.content];
      }, 0)),
          scroll = size > 0 && scrollSize > size; // when there is no tab, in Chrome, size === 0 and scrollSize === 1

      if (this.scrollable !== scroll) {
        this.scrollable = scroll;
      } // Arrows need to be updated even if the scroll status was already true


      scroll === true && this.$nextTick(function () {
        return _this3.__updateArrows();
      });
      var justify = size < parseInt(this.breakpoint, 10);

      if (this.justify !== justify) {
        this.justify = justify;
      }
    },
    __animate: function __animate(oldName, newName) {
      var _this4 = this;

      var oldTab = oldName !== void 0 && oldName !== null && oldName !== '' ? this.$children.find(function (tab) {
        return tab.name === oldName;
      }) : null,
          newTab = newName !== void 0 && newName !== null && newName !== '' ? this.$children.find(function (tab) {
        return tab.name === newName;
      }) : null;

      if (oldTab && newTab) {
        var oldEl = oldTab.$el.getElementsByClassName('q-tab__indicator')[0],
            newEl = newTab.$el.getElementsByClassName('q-tab__indicator')[0];
        clearTimeout(this.animateTimer);
        oldEl.style.transition = 'none';
        oldEl.style.transform = 'none';
        newEl.style.transition = 'none';
        newEl.style.transform = 'none';
        var oldPos = oldEl.getBoundingClientRect(),
            newPos = newEl.getBoundingClientRect();
        newEl.style.transform = this.vertical === true ? "translate3d(0,".concat(oldPos.top - newPos.top, "px,0) scale3d(1,").concat(newPos.height ? oldPos.height / newPos.height : 1, ",1)") : "translate3d(".concat(oldPos.left - newPos.left, "px,0,0) scale3d(").concat(newPos.width ? oldPos.width / newPos.width : 1, ",1,1)"); // allow scope updates to kick in (QRouteTab needs more time)

        this.$nextTick(function () {
          _this4.animateTimer = setTimeout(function () {
            newEl.style.transition = 'transform .25s cubic-bezier(.4, 0, .2, 1)';
            newEl.style.transform = 'none';
          }, 70);
        });
      }

      if (newTab && this.scrollable === true) {
        var _this$$refs$content$g = this.$refs.content.getBoundingClientRect(),
            left = _this$$refs$content$g.left,
            width = _this$$refs$content$g.width,
            top = _this$$refs$content$g.top,
            height = _this$$refs$content$g.height,
            _newPos = newTab.$el.getBoundingClientRect();

        var offset = this.vertical === true ? _newPos.top - top : _newPos.left - left;

        if (offset < 0) {
          this.$refs.content[this.vertical === true ? 'scrollTop' : 'scrollLeft'] += Math.floor(offset);

          this.__updateArrows();

          return;
        }

        offset += this.vertical === true ? _newPos.height - height : _newPos.width - width;

        if (offset > 0) {
          this.$refs.content[this.vertical === true ? 'scrollTop' : 'scrollLeft'] += Math.ceil(offset);

          this.__updateArrows();
        }
      }
    },
    __updateArrowsFn: function __updateArrowsFn() {
      var content = this.$refs.content,
          rect = content.getBoundingClientRect(),
          pos = this.vertical === true ? content.scrollTop : content.scrollLeft;
      this.leftArrow = pos > 0;
      this.rightArrow = this.vertical === true ? Math.ceil(pos + rect.height) < content.scrollHeight : Math.ceil(pos + rect.width) < content.scrollWidth;
    },
    __animScrollTo: function __animScrollTo(value) {
      var _this5 = this;

      this.__stopAnimScroll();

      this.__scrollTowards(value);

      this.scrollTimer = setInterval(function () {
        if (_this5.__scrollTowards(value)) {
          _this5.__stopAnimScroll();
        }
      }, 5);
    },
    __scrollToStart: function __scrollToStart() {
      this.__animScrollTo(0);
    },
    __scrollToEnd: function __scrollToEnd() {
      this.__animScrollTo(9999);
    },
    __stopAnimScroll: function __stopAnimScroll() {
      clearInterval(this.scrollTimer);
    },
    __scrollTowards: function __scrollTowards(value) {
      var content = this.$refs.content;
      var pos = this.vertical === true ? content.scrollTop : content.scrollLeft,
          done = false;
      var direction = value < pos ? -1 : 1;
      pos += direction * 5;

      if (pos < 0) {
        done = true;
        pos = 0;
      } else if (direction === -1 && pos <= value || direction === 1 && pos >= value) {
        done = true;
        pos = value;
      }

      content[this.vertical === true ? 'scrollTop' : 'scrollLeft'] = pos;

      this.__updateArrows();

      return done;
    }
  },
  activated: function activated() {
    this.__recalculateScroll();
  },
  created: function created() {
    this.buffer = [];
    this.__updateArrows = this.arrowsEnabled === true ? this.__updateArrowsFn : noop;
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.bufferTimer);
    clearTimeout(this.animateTimer);
  },
  render: function render(h) {
    var child = [h(QResizeObserver, {
      on: cache(this, 'resize', {
        resize: this.__updateContainer
      })
    }), h('div', {
      ref: 'content',
      staticClass: 'q-tabs__content row no-wrap items-center self-stretch hide-scrollbar',
      class: this.innerClass,
      on: this.arrowsEnabled === true ? cache(this, 'scroll', {
        scroll: this.__updateArrowsFn
      }) : void 0
    }, slot(this, 'default'))];
    this.arrowsEnabled === true && child.push(h(QIcon, {
      staticClass: 'q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon',
      class: this.leftArrow === true ? '' : 'q-tabs__arrow--faded',
      props: {
        name: this.leftIcon || (this.vertical === true ? this.$q.iconSet.tabs.up : this.$q.iconSet.tabs.left)
      },
      on: cache(this, 'onL', {
        mousedown: this.__scrollToStart,
        touchstart: this.__scrollToStart,
        mouseup: this.__stopAnimScroll,
        mouseleave: this.__stopAnimScroll,
        touchend: this.__stopAnimScroll
      })
    }), h(QIcon, {
      staticClass: 'q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon',
      class: this.rightArrow === true ? '' : 'q-tabs__arrow--faded',
      props: {
        name: this.rightIcon || (this.vertical === true ? this.$q.iconSet.tabs.down : this.$q.iconSet.tabs.right)
      },
      on: cache(this, 'onR', {
        mousedown: this.__scrollToEnd,
        touchstart: this.__scrollToEnd,
        mouseup: this.__stopAnimScroll,
        mouseleave: this.__stopAnimScroll,
        touchend: this.__stopAnimScroll
      })
    }));
    return h('div', {
      staticClass: 'q-tabs row no-wrap items-center',
      class: this.classes,
      on: this.onEvents,
      attrs: {
        role: 'tablist'
      }
    }, child);
  }
});